import React, { Component } from 'react';
import './setup.css';
import { translate } from 'react-i18next';
import { graphql, compose } from 'react-apollo'
import { setLanguage } from "../graphql/mutations.js"
// import update from 'immutability-helper';
import { withCookies } from 'react-cookie';

import FlatUIButton from "../components/input/flat-ui-button.js"
import { CircularProgress } from 'material-ui/Progress';


class LanguagePage extends Component {

  state = {}
  
  constructor(props) {
    super(props)

    if (!props.cookies.get("session_cookie") || !props.cookies.get('language_choices')) {
      console.log("No session id or language choices. Rerouting")
      this.props.history.push("/")
      console.log(this.props.history)
    }

    console.log(this.props)
  }

  componentWillReceiveProps(nextProps) {
    console.log("RECEIVING PROPS", nextProps.data)
    // console.log(nextProps)

    
  }

  onSelected = (e, code) => {
    console.log(code)
    this.setState({ loading: true })
    this.props.i18n.changeLanguage(code)
    this.props.setLanguage({ language_code: code })
        .then(({ data }) => {
          console.log(data)
          this.props.cookies.remove('language_choices')
          setTimeout(() => {
            this.props.history.push('/m')
          }, 250)
        })
        .catch((error) => {
          console.log(error)
          const graphqlMsg = error.graphQLErrors && error.graphQLErrors[0] && error.graphQLErrors[0].message
          this.setState({
            loading: false,
            error: graphqlMsg || error.message || "Error: " + error.code
          })
        })
  }

  codeToUIString = (code) => {
    switch(code) {
      case 'en': return 'English'
      case 'zh-CN': return '普通话'
      case 'zh-HK': return '廣東話'
      default: return code
    }
  }

  render() {
    return (
      <div className="language-container">
      {
        this.props.cookies.get('language_choices') && this.props.cookies.get('language_choices').map(code => (
          <FlatUIButton key={code}
            variant="raised" 
            outline longAnswer={true} centeredAnswer={true}
            onClick={e => this.onSelected(e, code)}>
              { this.codeToUIString(code) }
          </FlatUIButton>
        ))
      }
      { this.state.loading && <CircularProgress /> }
      </div>
    )
  }
}

const TranslatedLanguagePage = translate('translations')(LanguagePage);

export default withCookies(
  compose(
    graphql(setLanguage, {
      props: ({ mutate, ownProps }) => ({
        setLanguage: ({ language_code }) =>
          mutate({ 
            variables: { 
              session_id: ownProps.cookies.get("session_cookie") && ownProps.cookies.get("session_cookie").session_id,
              language_code: language_code,
            }
          })
      })
    })
  )(TranslatedLanguagePage)
);


// WEBPACK FOOTER //
// ./src/pages/language.js